module.exports = __webpack_public_path__ + "static/media/michael@2x.88f98eac.png";